import DialogCancelOrderConfirm from './DialogCancelOrderConfirm'
import DialogCodeConfirm from './DialogCodeConfirm'
import DialogError from './DialogError'
import DialogNotAllowBooking from './DialogNotAllowBooking'
import DialogPopupText from './DialogPopupText'
import DialogAiAgentPopup from './DialogAiAgentPopup'
import DialogWlistCalendar from './DialogWlistCalendar'
import DialogWlistTime from './DialogWlistTime'
import DialogCancelWlistConfirm from './DialogCancelWlistConfirm'
import DialogRequiredFields from './DialogRequiredFields'

const Dialog = {
  CancelOrderConfirm: DialogCancelOrderConfirm,
  CodeConfirm: DialogCodeConfirm,
  Error: DialogError,
  NotAllowBooking: DialogNotAllowBooking,
  PopupText: DialogPopupText,
  AiAgentPopup: DialogAiAgentPopup,
  WlistCalendar: DialogWlistCalendar,
  WlistTime: DialogWlistTime,
  CancelWlistConfirm: DialogCancelWlistConfirm,
  RequiredFields: DialogRequiredFields,
}

export default Dialog